import { render, staticRenderFns } from "./CurrentSaleLine.vue?vue&type=template&id=b537fbbc&scoped=true"
import script from "./CurrentSaleLine.vue?vue&type=script&lang=js"
export * from "./CurrentSaleLine.vue?vue&type=script&lang=js"
import style0 from "./CurrentSaleLine.vue?vue&type=style&index=0&id=b537fbbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b537fbbc",
  null
  
)

export default component.exports